module.exports = __webpack_public_path__ + "static/media/lockgate.efab787b.svg";